import { Navigate } from 'react-router';
import { ReactElement } from 'react';
import { ACTIVE_LOAN } from './routes';

type Props = {
  children: ReactElement;
};

export default function PublicRoute({ children }: Props) {
  const userNotAuthorized =
    !sessionStorage.getItem('token') ||
    window.location.search.includes('from2fa=true');
  if (userNotAuthorized) {
    return children;
  }

  return <Navigate to={ACTIVE_LOAN} replace />;
}
